const colors = {
  TR808: {
    background: "#2a2720",
    primary: "#dd1201",
    secondary: "#f47900",
    yellow: "#e3e007",
    white: "#edeacb",
  },
  TR909: {
    background: "#c9ccd3",
    primary: "#3d4350",
    secondary: "#f47900",
    darkblue: "#4f5d66",
    grey: "#8d8885",
  },
};

export default colors;
